import React, { type FC } from 'react'
import cn from 'classnames'

import { type BaseProps } from 'types'
import styles from './style.scss'

export interface Props extends BaseProps {
  className?: string
  duration?: number
  delay?: number
}

const Fade: FC<Props> = ({ children, className, duration = 400, delay = 0 }) => {
  return (
    <div
      className={cn(styles['fade'], className)}
      style={{
        animationDuration: `${duration}ms`,
        animationDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  )
}

export default Fade
